/** Archivo descargado del backend: contenido + nombre que decidio el servidor (si vino). */
export interface DownloadedFile {
  blob: Blob;
  /** Nombre tomado de Content-Disposition; null si el header no vino o no se pudo leer. */
  filename: string | null;
}

/**
 * Extrae el nombre de archivo de una cabecera Content-Disposition.
 * Soporta `filename="x.pdf"` y la forma RFC 5987 `filename*=UTF-8''x%20y.pdf`.
 * Devuelve null si no hay nombre utilizable.
 */
export function parseContentDispositionFilename(header: string | null): string | null {
  if (!header) {
    return null;
  }

  const extended = /filename\*\s*=\s*(?:UTF-8|utf-8)''([^;]+)/i.exec(header);
  if (extended?.[1]) {
    try {
      const decoded = decodeURIComponent(extended[1].trim());
      if (decoded) {
        return decoded;
      }
    } catch {
      // formato invalido: se intenta el filename simple
    }
  }

  const simple = /filename\s*=\s*"?([^";]+)"?/i.exec(header);
  const name = simple?.[1]?.trim();
  return name || null;
}

/**
 * Dispara la descarga de un Blob en el navegador creando un enlace temporal.
 * Centraliza la logica usada por el wizard y el historico de resumenes.
 */
export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
